import React from 'react';
import { motion } from 'framer-motion';
import { FaCertificate, FaAward } from 'react-icons/fa';
import './Certifications.css';

const certifications = [
  { name: 'LangChain: Chat with Your Data', issuer: 'DeepLearning.AI', year: '2024' },
  { name: 'Build Chat Applications with OpenAI and LangChain', issuer: '365 DataScience', year: '2024' },
  { name: 'Machine Learning Engineer Certificate', issuer: 'DataCamp', year: '2024' },
  { name: 'Machine Learning Specialization', issuer: 'Coursera', year: '2024' },
  { name: 'Data Analyst Certificate', issuer: 'DataCamp', year: '2024' },
  { name: 'Data Engineering', issuer: 'DataCamp', year: '2024' },
  { name: 'Data Scientist Certificate', issuer: 'DataCamp', year: '2024' },
  { name: 'AWS Specialization', issuer: 'Coursera', year: '2024' },
  { name: 'Natural Language Processing Specialization', issuer: 'Coursera', year: '2024' },
  { name: 'Mathematics for Machine Learning', issuer: 'Coursera', year: '2024' },
  { name: 'Intermediate SQL', issuer: 'DataCamp', year: '2024' },
];

const awards = [
  { name: 'XP Champ Award', issuer: 'DataCamp × Sunway SRC', year: '2024' },
];

const Certifications = () => {
  return (
    <section id="certifications" className="certifications">
      <div className="container">
        <div className="section-header">
          <span className="section-label">{'// Credentials'}</span>
          <h2 className="section-title">Certifications & Awards</h2>
        </div>

        {/* Awards */}
        <div className="certifications__awards">
          {awards.map((award, idx) => (
            <motion.div
              className="certifications__award-card"
              key={idx}
              initial={{ opacity: 0, y: 20 }}
              whileInView={{ opacity: 1, y: 0 }}
              viewport={{ once: true }}
              transition={{ duration: 0.5 }}
            >
              <div className="certifications__award-icon">
                <FaAward />
              </div>
              <div>
                <h4>{award.name}</h4>
                <span>{award.issuer}, {award.year}</span>
              </div>
            </motion.div>
          ))}
        </div>

        {/* Certifications */}
        <div className="certifications__grid">
          {certifications.map((cert, idx) => (
            <motion.div
              className="certifications__card"
              key={idx}
              initial={{ opacity: 0, y: 15 }}
              whileInView={{ opacity: 1, y: 0 }}
              viewport={{ once: true }}
              transition={{ delay: idx * 0.05, duration: 0.4 }}
            >
              <FaCertificate className="certifications__card-icon" />
              <div>
                <h4 className="certifications__card-name">{cert.name}</h4>
                <span className="certifications__card-issuer">{cert.issuer}, {cert.year}</span>
              </div>
            </motion.div>
          ))}
        </div>
      </div>
    </section>
  );
};

export default Certifications;
